"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagNU = function FlagNU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74,12.18H-185.94A7.06,7.06,0,0,1-193,5.12V-114.94a7.06,7.06,0,0,1,7.06-7.06H4.74a7.06,7.06,0,0,1,7.06,7.06V5.12a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69.41-54.91A21.19,21.19,0,0,1-90.6-33.72a21.19,21.19,0,0,1-21.19-21.19A21.19,21.19,0,0,1-90.6-76.09,21.19,21.19,0,0,1-69.41-54.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-89.17-72.09l3.54,10.62,11.19.08a1.51,1.51,0,0,1,.88,2.72l-9,6.65,3.38,10.66a1.51,1.51,0,0,1-2.32,1.68l-9.1-6.5-9.1,6.5A1.51,1.51,0,0,1-102-41.36L-98.64-52l-9-6.65a1.51,1.51,0,0,1,.88-2.72l11.19-.08L-92-72.09a1.51,1.51,0,0,1,2.86,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-147.8-63.44l1.91,5.71,6,0a.81.81,0,0,1,.47,1.46l-4.83,3.58,1.81,5.73a.81.81,0,0,1-1.24.9l-4.9-3.49L-153.46-46a.81.81,0,0,1-1.24-.9l1.81-5.73-4.84-3.58a.81.81,0,0,1,.48-1.46l6,0,1.91-5.71a.8.8,0,0,1,1.53,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.33-63.44l1.9,5.71,6,0a.81.81,0,0,1,.47,1.46l-4.84,3.58L-26-46.92a.81.81,0,0,1-1.25.9l-4.89-3.49L-37-46a.8.8,0,0,1-1.24-.9l1.81-5.73-4.84-3.58a.81.81,0,0,1,.47-1.46l6,0,1.9-5.71a.81.81,0,0,1,1.54,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-89.74-106.3l1.9,5.7,6,0a.81.81,0,0,1,.47,1.46l-4.84,3.57,1.82,5.74a.81.81,0,0,1-1.25.9l-4.89-3.49-4.89,3.49a.81.81,0,0,1-1.25-.9l1.82-5.74-4.84-3.57a.81.81,0,0,1,.47-1.46l6,0,1.9-5.7a.81.81,0,0,1,1.54,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-89.74-19.57l1.9,5.71,6,0a.81.81,0,0,1,.47,1.47l-4.84,3.57L-84.37-3a.82.82,0,0,1-1.25.91l-4.89-3.5-4.89,3.5A.82.82,0,0,1-96.65-3l1.82-5.73-4.84-3.58a.81.81,0,0,1,.47-1.46l6,0,1.9-5.71a.82.82,0,0,1,1.54,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagNU;
exports["default"] = _default;